<template>
<div class="breadcrumbs">
	<span v-for="(breadcrumb,index) in getCurrentCompany.breadcrumbs" :key="index">
		<span v-if="index > 0"> > </span>
		<router-link :to="{name: 'companies', params: {cid: breadcrumb [0]}}"
		>{{breadcrumb[1]}}</router-link>
	</span>
</div>
</template>

<script>
import { mapGetters } from "vuex";

export default{
    name:'Breadcrumbs',
    computed: {
        ...mapGetters(["getCurrentCompany"])
    },
}
</script>

<style>
</style>
